export default "__VITE_ASSET__BxRevvEV__"